(function () {
    'use strict';

    var $ = require('jquery');
    var $block = $('.block');

    if ($block.length > 0) {

        $block.waypoint(function (direction) {

            if (direction === 'down') {
                $(this.element).addClass('animate');
            } else {
                $(this.element).removeClass('animate');
            }

        }, {
            offset: '85%'
        });

    }

    $('.button.primary').each(function () {
        if ($(this).find('.line').length === 0) {

            var text = $(this).html();
            $(this).html('<span class="line">'+ text +'</span>');

        }
    });

})();